import { http } from '@/helpers/easyindustriaapi/config';

export default class TvDevicesController {
    constructor(user, empresa) {
        this.currentUser = user;
        this.currentEmpresa = empresa;
    }

    get empresaId() {
        return this.currentEmpresa?.id;
    }

    async list() {
        const empresaId = this.empresaId;
        const { data } = await http.get(`/tv/devices?empresa_id=${empresaId}`);
        return data;
    }

    async authorize(code, name) {
        const payload = {
            code,
            name,
            empresa_id: this.empresaId,
        };
        const { data } = await http.post('/tv/devices/authorize', payload);
        return data;
    }

    async revoke(id) {
        const { data } = await http.delete(`/tv/devices/${id}?empresa_id=${this.empresaId}`);
        return data;
    }
}
